// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oiV8v:hover,\n.oiV8v:active {\n  background-color: var(--surface-brand-hover) !important;\n}\n\n.G72FY:hover,\n.G72FY:active {\n  background-color: var(--surface-secondary-hover) !important;\n}\n\n.gZ7RL {\n  padding: var(--space-100) var(--space-200);\n}\n\n.gZ7RL svg {\n    width: 24px !important;\n    height: 24px !important;\n    margin-right: var(--space-100);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": "oiV8v",
	"demoButton": "G72FY",
	"menuItem": "gZ7RL"
};
export default ___CSS_LOADER_EXPORT___;
